import { Component, inject, Input } from '@angular/core';
import { LeadDetailsService } from '../../../../services/lead-details.service';
import { catchError, throwError } from 'rxjs';
import { GlobalErrorHandlerService } from '../../../../shared/services/global-error-handler.service';

@Component({
  selector: 'ppl-lead-detail-summary-training-tile',
  standalone: true,
  imports: [],
  templateUrl: './lead-detail-summary-training-tile.component.html',
  styleUrl: './lead-detail-summary-training-tile.component.css',
})
export class LeadDetailSummaryTrainingTileComponent {
  @Input({ required: true }) programCode!: string;
  @Input({ required: true }) selectedProviderId!: number;

  redirectUrl: string = '';
  nevvonId: string = '';
  leadDetailsService = inject(LeadDetailsService);
  errorHandler = inject(GlobalErrorHandlerService);

  ngOnInit() {
    this.leadDetailsService
    .fetchProviderNevvonId(this.programCode, this.selectedProviderId)
    .pipe(
      catchError((err) => {
        return throwError(() => this.errorHandler.handleError(err));
      }),
    )
    .subscribe({
      next: (apiResponse) => {
        if (apiResponse?.responsedata) {
          this.nevvonId = apiResponse.responsedata;
        }
      },
    });
  }

  handleRedirect(event: MouseEvent) {
    event.preventDefault();
    this.redirectToNevvonTraining();
  }

  redirectToNevvonTraining() {
    this.leadDetailsService
      .fetchProviderTrainingsRedirectUrl(this.programCode, this.selectedProviderId)
      .pipe(
        catchError((err) => {
          return throwError(() => this.errorHandler.handleError(err));
        }),
      )
      .subscribe({
        next: (apiResponse) => {
          if (apiResponse?.responsedata) {
            window.open(apiResponse.responsedata.redirectUrl, '_blank');
          }
        },
      });
  }
}
